<template>
  <div class="home">
    <!-- bannar+标语 -->
    <div class="bannar">
      <div class="bigtitle">
        <p class="bannerdes1">解决方案</p>
        <p class="bannerdes2">Solution</p>
        <div class="bannaerline"></div>
        <p class="bannerdes3">
          提供“垃圾分类”整体解决方案，打造智慧城市美好未来
        </p>
      </div>
    </div>

    <div class="smTab" :class="tabStyle == 1 ? 'smTab' : 'smTab2 tabMove'">
      <el-tabs
        v-model="activeName"
        @tab-click="tableclick"
        v-if="!detailStatus"
      >
        <el-tab-pane label="前端分类" name="item0"></el-tab-pane>
        <el-tab-pane label="易腐处理" name="item1"></el-tab-pane>
        <el-tab-pane label="资源利用" name="item2"></el-tab-pane>
        <el-tab-pane label="数字赋能" name="item3"></el-tab-pane>
      </el-tabs>
      <!-- 方法沿用 但是名字分开来只用于显示 -->
      <el-tabs
        v-model="activeName2"
        @tab-click="tableclick"
        v-if="detailStatus"
      >
        <el-tab-pane label="前端分类" name="item0_s"></el-tab-pane>
        <el-tab-pane label="易腐处理" name="item1_s"></el-tab-pane>
        <el-tab-pane label="资源利用" name="item2_s"></el-tab-pane>
        <el-tab-pane label="数字赋能" name="item3_s"></el-tab-pane>
      </el-tabs>
      <div class="smallLine"></div>
    </div>
    <div :class="tabStyle !== 1 ? 'smTab3' : ''"></div>

    <div class="model model2" v-show="!detailStatus" id="model2">
      <div class="model2title">
        <Minetitle2 :title1="titleArr[0].title1" :title2="titleArr[0].title2" />
      </div>
      <ul class="model2_ul">
        <li
          class="model2_li clearfix"
          v-for="(item, index) in dataArr"
          :key="item.id"
        >
          <i class="position"></i>
          <div class="model2_border" v-if="index % 2 == 0">
            <img class="model2_pic fl" :src="item.coverImg" alt="" />
            <div class="model2_part fr">
              <div class="part_title">{{ item.title }}</div>
              <div class="part_line"></div>
              <div class="part_des hidetxt3">{{ item.summary }}</div>
              <div class="part_product">
                使用产品：
                <!-- <div class="product_ul"> -->
                <b v-for="(item2, index) in item.productName" :key="index">{{
                  item2
                }}</b>
                <!-- </div> -->
              </div>
              <div class="btn_look" @click="lookDetail(index)">查看详情</div>
            </div>
          </div>
          <div class="model2_border" v-if="index % 2 !== 0">
            <img class="model2_pic fr" :src="item.coverImg" alt="" />
            <div class="model2_part fl">
              <div class="part_title">{{ item.title }}</div>
              <div class="part_line"></div>
              <div class="part_des hidetxt3">{{ item.summary }}</div>
              <div class="part_product">
                使用产品：
                <!-- <div class="product_ul"> -->
                <b v-for="(item2, index) in item.productName" :key="index">{{
                  item2
                }}</b>
                <!-- </div> -->
              </div>
              <div class="btn_look" @click="lookDetail(index)">查看详情</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- page2 详情 -->
    <div class="detail_main" v-show="detailStatus">
      <!-- 方案框架 -->
      <div class="detail_title">
        <div class="line1"></div>
        <div class="line2"></div>
        <p class="detail_des1">方案框架</p>
        <p class="detail_des2">Programme framework</p>
      </div>
      <img class="detail_floor1" :src="detailArr.coverImg" alt="" />
      <!-- 方案简介 -->
      <div class="detail_model1">
        <div class="model2_shadow"></div>
        <div class="detail_title">
          <div class="line1"></div>
          <div class="line2"></div>
          <p class="detail_des1">方案简介</p>
          <p class="detail_des2">brief introduction</p>
        </div>
        <div class="model2main" v-html="detailArr.context"></div>
      </div>
      <!-- 相关产品 -->
      <div class="detail_model2">
        <div class="model2_shadow"></div>
        <div class="detail_title">
          <div class="line1"></div>
          <div class="line2"></div>
          <p class="detail_des1">相关产品</p>
          <p class="detail_des2">Related products</p>
        </div>
        <!-- 产品列表 -->
        <ul class="detail_pro_ul" v-if="productList.length <= 3">
          <li class="pro_li" v-for="item in productList" :key="item.id">
            <img class="" :src="item.img" alt="" />
            <p class="pro_name">{{ item.title }}</p>
            <div class="pro_des hidetxt2">{{ item.context }}</div>
            <!-- 产品功能暂缺 -->
            <p class="pro_func"></p>
          </li>
        </ul>
        <!-- 产品个数大于3个 -->
        <ul class="detail_pro_ul" v-if="productList.length > 3">
          <swiper ref="mySwiper" :options="swiperOptions_s">
            <swiper-slide v-for="(item, index) in productList" :key="index">
              <li class="pro_li" :key="item.id">
                <img class="" :src="item.img" alt="" />
                <p class="pro_name">{{ item.title }}</p>
                <div class="pro_des hidetxt2">{{ item.context }}</div>
                <!-- 产品功能暂缺 -->
                <p class="pro_func"></p>
              </li>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-next btn_next_s"></div>
          <div class="swiper-button-prev btn_prev_s"></div>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Minetitle2 from "../components/minetitle2.vue";
import { getFunc } from "@/api/home";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { postPv } from "@/api/postPv";

// @ is an alias to /src
export default {
  inject: ["reload"],
  name: "home",
  data() {
    return {
      activeName2: "",
      activeName: "item0",
      titleArr: [{ id: 1, title1: "方案展示", title2: "Solution" }],
      dataArr: [],
      detailStatus: false,
      detailArr: {},
      productList: [], //详情的产品
      tabStyle: 1, //1代表平常样式 2代表悬浮
      swiperOptions_s: {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: ".btn_next_s", //前进
          prevEl: ".btn_prev_s", //后退
        },
        loop: true,
        observerParent: true,
        observer: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 2000, //自动切换的时间间隔，单位ms自动切换会在slide过渡完毕后才开始计时。
        },
      },
    };
  },
  watch: {},
  methods: {
    tableclick(tab, event) {
      let index = tab.index;
      //console.log(index);
      //跳转到相应锚点
      document
        .getElementsByClassName("position")
        [index].scrollIntoView({ block: "start", behavior: "smooth" });

      this.detailStatus = false;
    },
    lookDetail(index) {
      let arr = ["item0_s", "item1_s", "item2_s", "item3_s"];
      document
        .getElementsByClassName("bannerdes3")[0]
        .scrollIntoView({ block: "start", behavior: "smooth" });
      let that = this;
      that.detailArr = that.dataArr[index];
      // //console.log(that.detailArr.context);
      let id = that.dataArr[index].id;
      let url = "/blade-website/web/menu/solution/detail";
      let url2 = "/blade-website/web/index/readNum";
      getFunc(url, { solutionId: id })
        .then((res) => {
          that.detailStatus = true;
          that.activeName2 = arr[index];

          if (res.code == 200) {
            that.productList = res.data.productList;
          }
        })
        .catch((err) => {
          that.$message.warning("暂无详情");
        });
      getFunc(url2, { id: id, type: 1 }).then((res) => {
        // //console.log(res);
      });
    },
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let height = document.getElementsByClassName("bannar")[0].offsetHeight;

      if (scrollTop < height) {
        // //console.log("照常展示");
        this.tabStyle = 1;
        this.activeName = "item0";
      } else {
        this.tabStyle = 2;
      }

      let height1 =
        document.getElementsByClassName("model2_li")[0].offsetHeight;

      if (scrollTop > height + height1) {
        this.activeName = "item1";
      }
      if (scrollTop > height + height1 * 2) {
        this.activeName = "item2";
      }
      if (scrollTop > height + height1 * 3) {
        this.activeName = "item3";
      }
    },
  },
  mounted() {
    let thiz = this;
    let url1 = "/blade-website/web/menu/solution"; //解决方案
    var type;
    // this.$router.onReady(() => {
    //   type = this.$route.query.keyPath;
    // });
    thiz.$nextTick(() => {
      // let typeList = ["3-1", "3-2", "3-3", "3-4"];
      // let typeIndex = typeList.indexOf(type);
      // document
      //   .getElementsByClassName("position")
      //   [typeIndex].scrollIntoView({ block: "start", behavior: "smooth" });
      getFunc(url1).then((res) => {
        if (res.code == 200) {
          const data1 = res.data;
          // //console.log(data1);
          let titleArr = [
            "前端生活垃圾分类解决方案",
            "易腐垃圾处理解决方案",
            "资源化利用解决方案",
            "数字赋能解决方案",
          ];
          for (var i in data1) {
            if (data1[i].productName.indexOf(",") > -1) {
              data1[i].productName = data1[i].productName.split(",");
            }
            data1[i].title = titleArr[i];
          }
          thiz.dataArr = data1;

          // let typeList = ["3-1", "3-2", "3-3", "3-4"];
          // let typeIndex = typeList.indexOf(type);
          // //console.log(typeIndex);
          // document
          //   .getElementsByClassName("position")
          //   [typeIndex].scrollIntoView({ block: "start", behavior: "smooth" });
        }
      });
      window.addEventListener("scroll", this.handleScroll);
      postPv("https://www.azureflying.com/api/blade-website/analytics/access")
        .then((res) => {})
        .catch((err) => {});
      //发送pv
    });
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  components: { Minetitle2 },
};
</script>
<style scoped>
.home {
  width: 100%;
  overflow-x: hidden;
  padding-top: 80px;
  background: #f7f7f7;
}
.bannar {
  width: 100%;
  height: 673px;
  position: relative;
  background: url("../../public/img/solution/bannar.jpg") no-repeat;
  background-size: cover;
}

.bigtitle {
  width: 680px;
  position: absolute;
  left: 320px;
  top: 130px;
}
.bannerdes1 {
  font-size: 76px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  line-height: 72px;
  margin-bottom: 48px;
  letter-spacing: 10px;
}
.bannerdes2 {
  font-size: 40px;
  line-height: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #fff;
  margin-bottom: 79px;
  letter-spacing: 3px;
}
.bannaerline {
  width: 68px;
  height: 6px;
  background: #cccccc;
  margin-bottom: 21px;
}
.bannerdes3 {
  width: 100%;
  height: auto;
  line-height: 60px;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #fff;
  letter-spacing: 5px;
}

.model {
  width: 88%;
  max-width: 1702px;
  margin: 0 auto;
  position: relative;
}
.model2title {
  padding-left: 210px;
}
.model2_ul {
  width: 100%;
  height: auto;
}
.model2_li {
  width: 100%;
  padding: 0 210px 103px 210px;
  border-bottom: 1px solid #dddddd;
  margin-bottom: 102px;
  position: relative;
}
.model2_ul .model2_li:hover .part_title {
  animation: AntTitle 1s ease-in-out;
  color: #409eff;
}
@keyframes AntTitle {
  0% {
    opacity: 0;
    color: #333333;
  }
  100% {
    opacity: 1;
    color: #409eff;
  }
}
.model2_ul .model2_li:hover .part_des {
  animation: AntDes 0.75s linear;
}
@keyframes AntDes {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
.model2_ul .model2_li:hover b:nth-child(1) {
  animation: btnMove 1s;
}
.model2_ul .model2_li:hover b:nth-child(2) {
  animation: btnMove 1s 0.25s;
}
.model2_ul .model2_li:hover b:nth-child(3) {
  animation: btnMove 1s 0.5s;
}
.model2_ul .model2_li:hover b:nth-child(4) {
  animation: btnMove 1s 0.75s;
}
.model2_ul .model2_li:hover b:nth-child(5) {
  animation: btnMove 1s 1s;
}
.model2_ul .model2_li:hover .btn_look {
  color: white;
  background: #589ef8;
  animation: Antbtn 1s;
  border: none;
}
@keyframes Antbtn {
  0% {
    color: #333333;
    background: white;
    opacity: 0.8;
    border: 1px solid #999999;
  }
  100% {
    color: white;
    background: #589ef8;
    opacity: 1;
    border: none;
  }
}

@keyframes btnMove {
  0% {
    bottom: 0;
  }
  20% {
    bottom: 10px;
  }
  40% {
    bottom: 0;
  }
  100% {
    bottom: 0;
  }
}
/* .model2_ul .model2_li:nth-child(odd):hover div {
  animation: moveLf 1s ease-in-out;
}

@keyframes moveLf {
  0% {
    opacity: 0;
    top: -100px;
  }
  100% {
    opacity: 1;
    top: 0px;
  }
}

.model2_ul .model2_li:nth-child(even):hover div {
  animation: moveRt 1s ease-in-out;
} */

.model2_ul .model2_li:last-child {
  border: none;
}
.model2_border {
  width: 100%;
  height: 450px;
  background: WHITE;
  box-shadow: 0px 2px 35px 0px rgba(181, 186, 183, 0.1);
  border-radius: 0px 10px 10px 0px;
}
.model2_pic {
  width: 51%;
  height: 100%;
}
.model2_part {
  width: 49%;
  height: 100%;
  padding: 20px 42px 0 29px;
  position: relative;
}
.part_title {
  height: auto;
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  margin-bottom: 30px;
}
.part_line {
  width: 68px;
  height: 6px;
  background: #cccccc;
  border-radius: 5%;
  margin-bottom: 25px;
}
.part_des {
  height: 105px;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  line-height: 35px;
  margin-bottom: 44px;
}
.part_product {
  font-size: 18px;
  color: #666666;
  margin-bottom: 60px;
}
.part_product b {
  color: #589ef8;
  margin-right: 8px;
  font-weight: normal;
}

.btn_look {
  width: 157px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  border: 1px solid #999999;
  border-radius: 5px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  position: absolute;
  bottom: 45px;
}
.btn_look:hover {
  cursor: pointer;
}

/* 功能详情 */
.detail_main {
  width: 80%;
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
}
.detail_floor1 {
  width: 100%;
  margin-bottom: 87px;
}
.detail_title {
  width: 100%;
  height: auto;
  position: relative;
  margin-bottom: 41px;
}
.line1 {
  width: 43%;
  height: 1px;
  background: #dddddd;
  border-radius: 10%;
  position: absolute;
  left: 0;
  top: 50px;
}
.line2 {
  width: 43%;
  height: 1px;
  background: #dddddd;
  border-radius: 10%;
  position: absolute;
  right: 0;
  top: 50px;
}
.detail_des1 {
  width: 100%;
  height: auto;
  font-size: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
.detail_des2 {
  width: 100%;
  text-align: center;
  height: 13px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.model2main {
  width: 100%;
  height: auto;
  margin-bottom: 81px;
}
.info_lf {
  float: left;
  width: 50%;
  height: auto;
}
.info_rt {
  float: right;
  width: 50%;
  height: auto;
}
.model2_part1 {
  width: 100%;
  height: 500px;
  position: relative;
  margin-bottom: 31px;
}
.model2_part1 img {
  width: 100%;
  height: 100%;
}
.model2_part1Shadow {
  position: absolute;
  background: rgba(81, 154, 215, 0.6);
  padding: 75px 40px 0 40px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 55px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
/*  */
.model2_part2 {
  width: 100%;
  height: 350px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.model2_part2 video {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.btn_playVideo {
  width: 87px;
  height: 87px;
  position: relative;
  z-index: 2;
}

.model2_part3 {
  width: 100%;
  height: 350px;
  margin-bottom: 31px;
}
.model2_part3 img {
  width: 100%;
  height: 100%;
}
.model2_part4 img {
  width: 100%;
  height: 100%;
}
.model2_part4 {
  width: 100%;
  height: 500px;
  position: relative;
}
.model2_part4Shadow {
  position: absolute;
  background: rgba(112, 178, 107, 0.6);
  padding: 75px 40px 0 40px;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 55px;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 相关产品 */
.detail_pro_ul {
  width: 100%;
  height: 480px;
  margin-bottom: 74px;
  display: flex;
  justify-content: space-around;
  position: relative;
}
.pro_li {
  width: 100%;
  max-width: 406px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 2px 35px 0px rgba(181, 186, 183, 0.21);
  border-radius: 10px;
}
.pro_li:hover {
  transform: translateY(-17px);
  transition: transform 0.5s linear;
}

.pro_li img {
  width: 100%;
  height: 277px;
  margin-bottom: 37px;
}
.pro_name {
  padding: 0 20px;
  margin-bottom: 28px;
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  width: 100%;
  height: 26px;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pro_des {
  padding: 0 20px;
  width: 100%;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}
.btn_next_s {
  right: -100px;
}
.btn_prev_s {
  left: -100px;
}

/* 用于定位 */
.position {
  position: absolute;
  z-index: -1;
  left: 0%;
  top: -200px;
}
.model2_ul .model2_li:first-child .position {
  top: -250px;
}
</style>
